"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIDialogHeader;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function UIDialogHeader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      use = _ref.use,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "use"]);
  return _react.default.createElement("header", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-modal__header', 'uiDialogHeader', className, {
      'private-modal__header--with-toolbar': use === 'toolbar'
    })
  }), _react.default.createElement("div", {
    className: "private-modal__header__inner"
  }, children));
}

UIDialogHeader.propTypes = {
  children: _propTypes.default.node,
  use: _propTypes.default.oneOf(['default', 'toolbar'])
};
UIDialogHeader.displayName = 'UIDialogHeader';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/dialog/UIDialogHeader.js
// module id = 98
// module chunks = 5 6